export var styles = function () { return ({
    container: {
        margin: '10px auto',
        maxWidth: 350,
        overflow: 'hidden',
        width: '100%',
    },
}); };
//# sourceMappingURL=radioGroupForm.style.js.map